import React from "react";
import { Box } from "lucide-react";
import Tooltip from "./Tooltip";
import { EntireObjectIcon } from "./Icons";

const BUTTON_CLASS_NAME =
  "h-8 w-8 rounded-sm text-sm transition-colors flex items-center justify-center text-gray-200 hover:bg-gray-700/90";

const DeleteMenuContent = ({
  onDeleteBody = null,
  onDeleteObject = null,
  bodyLabel = "Delete body",
  objectLabel = "Delete entire object",
}) => (
  <div className="flex items-center gap-1">
    {onDeleteBody ? (
      <Tooltip content={<span className="whitespace-nowrap">{bodyLabel}</span>}>
        <button
          type="button"
          aria-label={bodyLabel}
          onClick={onDeleteBody}
          className={BUTTON_CLASS_NAME}
        >
          <Box className="w-4 h-4" aria-hidden="true" />
        </button>
      </Tooltip>
    ) : null}
    {onDeleteObject ? (
      <Tooltip content={<span className="whitespace-nowrap">{objectLabel}</span>}>
        <button
          type="button"
          aria-label={objectLabel}
          onClick={onDeleteObject}
          className={BUTTON_CLASS_NAME}
        >
          <EntireObjectIcon className="w-4 h-4" />
        </button>
      </Tooltip>
    ) : null}
  </div>
);

export default DeleteMenuContent;
